import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "unslugify"
})
export class UnSlugifyPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.replace(new RegExp("_", "g"), " ");
    } else {
      return value;
    }
  }
}
